import Box from '@mui/material/Box';
import { useMemo } from 'react';
import NRReactGrid from '../../../NRReactGrid/NRReactGrid';
import { DateProvider } from '../../../NRReactGridCustomComponents/NRCustomProviders/DateProvider';
import { CONSTANTS } from '../../../../constants/constants';
import { VULNERABILITY_JIRA_TICKETS_LABELS } from './vulnerabilityJiraTickets.constants';
import { NRJiraTicketIdProvider } from './providers/NRJiraTicketIdProvider';
import { NRJiraTicketStatusProvider } from './providers/NRJiraTicketStatusProvider';

const COLUMNS = [
  {
    title: { value: VULNERABILITY_JIRA_TICKETS_LABELS.TICKET_ID },
    name: 'ticketKey',
    sortDisabled: true,
    hideFilter: true
  },
  {
    title: { value: VULNERABILITY_JIRA_TICKETS_LABELS.STATUS },
    name: 'status',
    sortDisabled: true,
    hideFilter: true
  },
  {
    title: { value: VULNERABILITY_JIRA_TICKETS_LABELS.ASSIGNEE },
    name: 'assignee',
    sortDisabled: true,
    hideFilter: true
  },
  {
    title: { value: VULNERABILITY_JIRA_TICKETS_LABELS.UPDATED },
    name: 'updatedAt',
    sortDisabled: true,
    hideFilter: true,
    dateFormat: CONSTANTS.DATE_FORMAT.MONTH_YEAR_SHORT
  }
];

const COLUMN_EXTENSIONS = [
  { columnName: 'ticketKey', align: 'left', width: 170 },
  { columnName: 'status', align: 'left', width: 140 },
  { columnName: 'assignee', align: 'left', width: 170 },
  { columnName: 'updatedAt', align: 'left' }
];

function NRJiraTicketsTable({ tickets = [] }) {
  const rows = useMemo(() => tickets.map(ticket => ({ ...ticket })), [tickets]);

  return (
    <Box
      sx={{
        borderTop: theme => `1px solid ${theme.palette.divider}`,
        '& .MuiPaper-root': {
          backgroundColor: 'transparent'
        }
      }}
    >
      <NRReactGrid
        rows={rows}
        columns={COLUMNS}
        columnExtensions={COLUMN_EXTENSIONS}
        embedded
        showIntegratedSelection={false}
        showSelectAll={false}
        showFilterSelector={false}
        addDefaultSorting={false}
        statesArray={[]}
        renderersArray={[]}
        providersArray={[
          <NRJiraTicketIdProvider key="nrJiraTicketIdProvider" for={['ticketKey']} />,
          <NRJiraTicketStatusProvider key="nrJiraTicketStatusProvider" for={['status']} />,
          <DateProvider key="jiraTicketUpdatedAtProvider" for={['updatedAt']} />
        ]}
        showIntegratedPagination={false}
        allowColumnReOrdering={false}
        elevation={0}
        variant="elevation"
      />
    </Box>
  );
}

export default NRJiraTicketsTable;
